import React, { Component } from 'react';
import { Grid } from '@mui/material';
import { inject } from 'mobx-react';

@inject('menuStore')
class DisplayTopping extends Component {
  render() {
    const { toppingGroups, menuStore } = this.props;

    return (
      <Grid item container direction="column">
        {toppingGroups.map(toppingGroup =>
          toppingGroup.toppings.map((topping, toppingIndex) => (
            <Grid
              item
              container
              direction="row"
              gap={1}
              key={toppingIndex}
              style={{ fontSize: '12px', color: '#9D9B9B' }}
            >
              <Grid item xs>
                {`${toppingGroup.name} (${topping.name})`}
              </Grid>
              <Grid item>{topping.qty > 1 ? `x${topping.qty}` : ''}</Grid>
              <Grid item style={{ width: '92px', textAlign: 'right' }}>
                (+{menuStore.numberFormatByLocale(topping.addPrice * topping.qty)})
              </Grid>
            </Grid>
          )),
        )}
      </Grid>
    );
  }
}

export default DisplayTopping;
